<template>
    <v-dialog v-if="! state" v-model="dialog" max-width="600">
        <template #activator="{ on }">
            <v-btn
                @click="$tracking.event.tryout.preStart(tryoutTrackingTitle)"
                v-on="on"
                large
                color="primary"
                class="mt-4"
            >
                Kerjakan Tryout
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                Kerjakan tryout?
            </v-card-title>

            <v-card-text>
                <ol>
                    <li>
                        Pastikan koneksi internet anda stabil.
                    </li>
                    <li>
                        Anda hanya memiliki 1 (satu) kali kesempatan mengerjakan tryout.
                    </li>
                    <li>
                        Anda dapat menekan tombol pause di layar bagian kanan atas apabila ingin keluar sementara dari tryout.
                    </li>
                    <li>
                        Begitu pula jika koneksi internet anda terputus, anda dapat melanjutkan kembali tanpa mengulang dari awal.
                    </li>
                    <li>
                        Gambar dapat anda zoom dengan pinch di smartphone/tablet, dan fitur zoom in di browser laptop/pc anda
                    </li>
                    <li>
                        Anda dapat menandai soal dengan menekan tombol flag di atas soal.
                    </li>
                    <li>
                        Navigasi seluruh soal tryout anda ada di bawah soal (pengguna smartphone/tablet) atau di samping soal (pengguna laptop/pc).
                    </li>
                    <li>
                        Anda dapat menggunakan mengaktifkan menu Auto Scroll untuk next secara otomatis setiap selesai menjawab soal
                    </li>
                    <li>
                        Setelah anda pilih Selesai > Selesai dan Kumpulkan untuk dinilai, tryout dianggap selesai dan tidak dapat diulang. Anda akan mendapat penilaian dan jawaban benar.
                    </li>
                    <li>
                        Jawaban dapat anda lihat setelah selesai mengerjakan.
                    </li>
                </ol>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="cancelPreStart" text>
                    Batal
                </v-btn>

                <v-btn @click="doTryout" text color="primary" :loading="$store.get('loader/loading', 'startTryout')">
                    Kerjakan
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-row v-else align="center" justify="end" class="mt-4 mr-4 mr-md-0">
        <template v-if="state === 'paused'">
            <div>
                Tryout sedang dijeda
            </div>

            <v-btn
                @click="resumeTryout"
                large
                color="primary"
                class="ml-4"
            >
                Lanjut kerjakan
            </v-btn>
        </template>

        <template v-else>
            <div>
                Kamu sudah mengerjakan tryout ini
            </div>
            <v-btn
                :to="{ name: 'grade.detail', params: { history_hash: historyHash } }"
                large
                color="primary"
                class="ml-4"
            >
                Pembahasan
            </v-btn>
        </template>
    </v-row>
</template>

<script>
export default {
    props: ['state', 'historyHash', 'tryout'],
    data() {
        return {
            dialog: false,
        }
    },

    computed: {
        tryoutTrackingTitle() {
            return `${this.tryout.title} ${this.$store.get('enrollment/selected@title')}`
        }
    },

    methods: {
        doTryout() {
            this.$api.post(`work/${this.$route.params.hash}`, {}, { loader: 'startTryout' })
                .then(response => {
                    this.$tracking.event.tryout.start(this.tryoutTrackingTitle)
                    this.$router.push({ name: 'work', params: { history_hash: response.data.hash } });
                })
        },

        resumeTryout() {
            this.$tracking.event.tryout.resume(this.tryoutTrackingTitle)
            this.$router.push({ name: 'work', params: { history_hash: this.historyHash } })
        },

        cancelPreStart() {
            this.dialog = false
            this.$tracking.event.tryout.cancel(this.tryoutTrackingTitle)
        }
    },
}
</script>
